module.exports = __webpack_public_path__ + "img/send-images.05910c2c.png";